import { EditorState } from '../types';

const isSameItems = (items1: string[], items2: string[]): boolean => {
  if (items1.length !== items2.length) {
    return false;
  }

  for (const item of items1) {
    if (!items2.includes(item)) {
      return false;
    }
  }

  return true;
};

export const setSelectedItems = (
  state: EditorState,
  selectedItems: string[],
): EditorState => {
  const lockedTrackItemIds = new Set(
    state.undoableState.tracks
      .filter((track) => track.locked)
      .map((track) => track.items)
      .flat(),
  );

  const filteredSelectedItems = selectedItems.filter(
    (itemId, index, arr) =>
      !lockedTrackItemIds.has(itemId) && arr.indexOf(itemId) === index,
  );

  const isSame = isSameItems(state.selectedItems, filteredSelectedItems);

  // 선택이 실제로 바뀌면 그룹 컨텍스트(activeGroupId)와 1급 그룹 멤버 depth 표시
  // (inspectedGroupMemberId)를 함께 해제한다(그룹 이탈). 단 선택이 동일하고 그룹 컨텍스트도
  // 없으면(같은 그룹 재선택·드래그 pointerup 등 선택 변화 아님) 변화 없음 — 멤버 depth 유지.
  if (isSame && state.activeGroupId === null) {
    return state;
  }

  return {
    ...state,
    selectedItems: filteredSelectedItems,
    activeGroupId: null,
    inspectedGroupMemberId: null,
  };
};
